export default "__VITE_ASSET__BmlsPU3G__"